import { ref, onMounted, onUnmounted } from 'vue'
import { Capacitor } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'

const INPUT_SELECTORS = 'input:not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable]'
const isNative = Capacitor.isNativePlatform()

export function useIsKeyboardOpen() {
	const isKeyboardOpen = ref(false)
	let closeTimer: ReturnType<typeof setTimeout> | null = null
	let nativeListeners: any[] = []

	function onFocusIn(e: FocusEvent) {
		if (isNative) return
		const target = e.target as HTMLElement
		if (!target.matches(INPUT_SELECTORS)) return
		if (closeTimer) clearTimeout(closeTimer)
		isKeyboardOpen.value = true
	}

	function onFocusOut(e: FocusEvent) {
		if (isNative) return
		const related = e.relatedTarget as HTMLElement | null
		if (related?.matches(INPUT_SELECTORS)) return
		closeTimer = setTimeout(() => {
			isKeyboardOpen.value = false
		}, 200)
	}

	onMounted(async () => {
		if (isNative) {
			try {
				const willShow = await Keyboard.addListener('keyboardWillShow', () => {
					isKeyboardOpen.value = true
				})
				const willHide = await Keyboard.addListener('keyboardWillHide', () => {
					isKeyboardOpen.value = false
				})
				nativeListeners.push(willShow, willHide)
			} catch (e) {
				console.warn('Keyboard listeners not available', e)
			}
		} else {
			document.addEventListener('focusin', onFocusIn)
			document.addEventListener('focusout', onFocusOut)
		}
	})

	onUnmounted(() => {
		if (closeTimer) clearTimeout(closeTimer)
		if (isNative) {
			nativeListeners.forEach(l => l.remove())
		} else {
			document.removeEventListener('focusin', onFocusIn)
			document.removeEventListener('focusout', onFocusOut)
		}
	})

	return { isKeyboardOpen }
}